/* tslint:disable */
 
import { AuthenticatedCollectionOption } from './authenticated-collection-option';
import { Permission } from './permission';

/**
 * (tsType: DataCollectionsShareModel, schemaOptions: { title: undefined })
 */
export class DataCollectionsShareModel {
  authenticated?: AuthenticatedCollectionOption;
  sharedTo?: Array<Permission>;
}
